import { createSlice } from '@reduxjs/toolkit';
import { APIStatus } from '@application/enums/api-status';
import { createAttendeePickupAssignmentAsync, updateAttendeePickupAssignmentAsync, getAllAttendeePickupAssignmentsAsync, getAssignedAttendeesByPickupLocationIdAsync, getUnassignedAttendeesByPickupLocationIdAsync, getAttendeePickupAssignmentByIdAsync, deleteAttendeePickupAssignmentAsync, unassignAttendeeFromVehicleAsync, assignAttendeeToVehicleAsync, getAttendeesByVehicleIdAsync, assignCoordinatorAsync, getUnassignedAttendeesByEventIdAsync, getAssignedAttendeesByEventIdAsync, reassignAttendeesToPickupLocationAsync } from './attendeePickupAssignmentThunk';
const initialState = {
    status: APIStatus.IDLE,
    assignment: undefined,
    assignments: null,
    assignedAttendees: null,
    unassignedAttendees: null,
    vehicleAttendees: null
};
export const attendeePickupAssignmentSlice = createSlice({
    name: 'attendeePickupAssignment',
    initialState,
    reducers: {
        resetAttendees: (state) => {
            state.assignedAttendees = undefined;
            state.unassignedAttendees = undefined;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(createAttendeePickupAssignmentAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(createAttendeePickupAssignmentAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.assignment = action.payload;
        })
            .addCase(createAttendeePickupAssignmentAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(updateAttendeePickupAssignmentAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(updateAttendeePickupAssignmentAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.assignment = action.payload;
        })
            .addCase(updateAttendeePickupAssignmentAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getAllAttendeePickupAssignmentsAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllAttendeePickupAssignmentsAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.assignments = action.payload;
        })
            .addCase(getAllAttendeePickupAssignmentsAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getAssignedAttendeesByPickupLocationIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAssignedAttendeesByPickupLocationIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.assignedAttendees = action.payload;
        })
            .addCase(getAssignedAttendeesByPickupLocationIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getUnassignedAttendeesByPickupLocationIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getUnassignedAttendeesByPickupLocationIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.unassignedAttendees = action.payload;
        })
            .addCase(getUnassignedAttendeesByPickupLocationIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getAttendeePickupAssignmentByIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAttendeePickupAssignmentByIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.assignment = action.payload;
        })
            .addCase(getAttendeePickupAssignmentByIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(deleteAttendeePickupAssignmentAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(deleteAttendeePickupAssignmentAsync.fulfilled, (state) => {
            state.status = APIStatus.SUCCESS;
        })
            .addCase(deleteAttendeePickupAssignmentAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(unassignAttendeeFromVehicleAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(unassignAttendeeFromVehicleAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.assignment = action.payload.data;
        })
            .addCase(unassignAttendeeFromVehicleAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(assignAttendeeToVehicleAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(assignAttendeeToVehicleAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.assignment = action.payload.data;
        })
            .addCase(assignAttendeeToVehicleAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getAttendeesByVehicleIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAttendeesByVehicleIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.vehicleAttendees = action.payload;
        })
            .addCase(getAttendeesByVehicleIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(assignCoordinatorAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(assignCoordinatorAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.assignment = action.payload.data;
        })
            .addCase(assignCoordinatorAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getUnassignedAttendeesByEventIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getUnassignedAttendeesByEventIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.unassignedAttendees = action.payload;
        })
            .addCase(getUnassignedAttendeesByEventIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getAssignedAttendeesByEventIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAssignedAttendeesByEventIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.assignedAttendees = action.payload;
        })
            .addCase(getAssignedAttendeesByEventIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(reassignAttendeesToPickupLocationAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(reassignAttendeesToPickupLocationAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
        })
            .addCase(reassignAttendeesToPickupLocationAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
    }
});
export const { resetAttendees } = attendeePickupAssignmentSlice.actions;
export default attendeePickupAssignmentSlice.reducer;
